import { ContentSharingDialogStageId, ContentSharingDialogStepId } from '../types'

const propsTemplate = {
  isOptional: false,
  isCompleted: false,
}

const stages = {
  Destination: { ...propsTemplate, id: ContentSharingDialogStageId.Destination, label: 'Destination' },
}

const steps = {
  SelectContentForms: { ...propsTemplate, label: 'Select forms', id: ContentSharingDialogStepId.SelectContentForms },
  SelectGalleryPages: { ...propsTemplate, label: 'Select pages', id: ContentSharingDialogStepId.SelectGalleryPages },
  SelectTenantDestination: {
    ...propsTemplate,
    label: 'Select tenant destination',
    id: ContentSharingDialogStepId.SelectTenantDestination,
  },
  SelectContentDestinationType: {
    ...propsTemplate,
    label: 'Select content destination type',
    id: ContentSharingDialogStepId.SelectContentDestinationType,
  },
  SelectContentDestination: {
    ...propsTemplate,
    label: 'Select existing content',
    id: ContentSharingDialogStepId.SelectContentDestination,
  },
  SelectUser: { ...propsTemplate, label: 'Select user', id: ContentSharingDialogStepId.SelectUser },
  NotifyReviewers: { ...propsTemplate, label: 'Notify reviewers', id: ContentSharingDialogStepId.NotifyReviewers },
}

const requestToLinkContentStages = [
  {
    ...stages.Destination,
    steps: [steps.SelectTenantDestination, steps.SelectUser, steps.SelectContentDestination],
  },
]

export function getContentSharingDialogStages() {
  return requestToLinkContentStages
}
